import React from "react";
import "./content-title.sass"
const ContentTitle = ({ title }) => {
  return <h2 className="text-black contentTitle">{title}</h2>;
};

export default ContentTitle;
